module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('data-form', {
    attrs: {
      "entity": _vm.formData,
      "fields": {
        'version': {
          disabled: true
        },
        'commitHash': {
          disabled: true
        },
        'espVersion': {
          disabled: true
        },
        'ifVersion': {
          disabled: true
        },
        'ip': {
          disabled: true
        },
        'rssi': {
          disabled: true
        },
        'lastHeartbeat': {
          disabled: true,
          type: 'datetime'
        },
        'lastWifiReconnect': {
          disabled: true,
          type: 'datetime'
        },
        'lastMqttReconnect': {
          disabled: true,
          type: 'datetime'
        }
      },
      "buttons": [],
      "cancel": false
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('event-table', {
    attrs: {
      "filters": _vm.eventFilters,
      "columns": ['occured', '[T]name'],
      "showSearch": false
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5947d9ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/controller/ControllerDiagnosis.vue
// module id = 1002
// module chunks = 2